/* eslint-disable max-len */
export const SUPPORT_MAILTO = 'mailto:support@backrs.com?subject=Backrs App - Contact Request';

export default {
  common: {
    teams: 'Teams',
    proteges: 'Proteges',
    explore: 'Home',
    goals: 'Goals',
    addGoal: 'Add a goal',
    addPost: 'Add a post',
    tasks: 'Tasks',
    updates: 'Updates',
    dismiss: 'Dismiss',
    sponsoredBy: 'Sponsored by',
    panels: 'Panels',
    saveAndContinue: 'Save & Continue',
    save: 'Save',
    submit: 'Submit',
  },
  login: {
    useEmailAndPw: 'Please login using email and password',
    phoneLoginUnavailable: 'Phone login is unavailable',
    greeting: 'Two ways to log in:',
    prompt: {
      beginning: 'Log in or',
      middle: ' sign up ',
      end: 'to get started',
    },
    placeholders: {
      email: 'Email',
      password: 'Password',
      phone: 'Mobile Number',
    },
    forgotPassword: 'Forgot password?',
    decorativeDivider: 'OR',
    tryLogin: 'Log in',
    resetPassword: 'If you have an account, you will receive an email to reset your password.',
    unified: {
      title: 'Log in to Backrs',
      getStartedPrompt: 'Log in or sign up to get started.',
      getStartedButton: 'sign up',
      forgotPassword: 'Forgot Password?',
      letsGo: "Let's go!",
      phonePlaceholder: 'Mobile number',
      error: {
        invalidPhone: 'Please enter a valid phone number',
        invalidEmail: 'Please enter a valid email',
        emailRequired: 'Email is required',
        passwordRequired: 'Password is required',
        login: {
          userNameOrPassword: 'Log in failed: Invalid username or password',
          phone: 'Log in failed: Invalid phone number',
          genericError:
            'An error occurred while logging in. Please try again or contact an administrator for assistance.',
        },
      },
      otp: {
        title: 'Enter the verification code we just texted you',
        noCode: "Don't see a code?",
        logIn: 'Log In',
        resendCode: 'Enter your phone number to resend your verification code.',
        contactSupportPrompt: 'Still not working? ',
        contactSupportButton: 'Contact support.',
      },
    },
  },
  onboarding: {
    register: 'Register Here',
    login: 'Login',
    joinTeam: 'Join a panel',
    getStarted: 'Get Started',
    whatIsBackrs: 'What is backrs?',
    learn: 'Learn more',
    noAccount: "Don't have an account?",
    registerHeader: 'Join the community.',
    registerBtn: 'Save & Continue',
    explore: 'Skip and keep exploring',
    tsAndCs: ' I certify that I am 14 years of age or older.',
    areYouAStudent: 'Quick Q: Are you a student?',
    whatTypeOfStudent: 'Are you in high school, trade school, college, or graduate school?',
    yes: 'Yes!',
    nope: 'Nope.',
    youreInPage: {
      youreIn: "You're In!",
      getStarted: 'Ready to do some good? Share a little about yourself so you can give and get personalized support!',
      mentor: 'Mentor a student',
      startBacking: 'Start backing a protege based on your common interests, profile, and preferences.',
      backOnDemand: 'Back on-demand',
      aboutYourself: 'Tell us about yourself, and we’ll send relevant backing opportunities based on your experiences.',
      exploreApp: 'Explore the app',
      checkCommunity: 'Check out the community feed, read backing resources, and contribute where you can.',
      protegeApply: 'Apply to be a protege',
      cta: "Let's do it!",
    },
    whatsNext: {
      title: 'What’s next?',
      panel: {
        title: 'Join a Student’s Panel',
        body: 'Get matched with a student whose goals you can champion on an ongoing basis.',
      },
      network: {
        title: 'Connect in Networks',
        body: 'Answer other’s questions, post resources/opportunities, and celebrate wins in your Networks.',
      },
    },
    whatsNextStudent: {
      title: 'Wahoo!',
      body: 'We’ll start adding you to your Networks. What do you want to do next?',
      goals: {
        title: 'Set your goals',
        body: 'Let our community members know what you want them to help you achieve!',
      },
      profile: {
        title: 'Build your profile',
        body: 'Share info about your interests and background that will help community members connect!',
      },
    },
    inNetworks: {
      title: 'How to give back in Networks:',
      body: [
        'Answer a question posted by a community member.',
        'Comment on a Backstage Pass Post with your reflections/insights.',
        'Post a resource or opportunity you think might be helpful.',
      ],
      ctaLabel: 'Got it? Let’s go!',
    },
    readyToBack: {
      youreReady: 'Choose how you’d like to get started:',
      backProtege: 'Back a protege',
      startBacking: 'Get matched with a protege whose goals you can champion over time',
      backInNetwork: 'Back in networks',
      affinityNetwork: 'Share insights, resources, and opportunities with proteges in your Affinity Networks.',
    },
    tac: {
      acceptBtac: 'By registering, I accept',
      btac: 'Backrs Terms & Conditions',
    },
    errors: {
      registrationFailed: (showPartial) => `An error has occurred.${showPartial && ' Try again or '}`,
      enterValidInviteCode: 'Please enter a valid Invite Code.',
    },
    aboutBackrs: 'About Backrs',
    infoModalText: {
      inviteCode: 'If you’re a student or professional that’s affiliated with one of our school, institutional, or employer partners, you may have been given an invite code which will help us personalize your experience.',
      emailConfirmation: 'Backrs will use this email address to send you updates and notifications.',
    },
  },
  welcome: {
    greeting: 'Welcome to Backrs!',
    explore: 'Keep exploring',
    generalDescription:
      'We are a platform that helps young people achieve their aspirations by building a team of adults who have their back.',
    protegeDescription: 'A protege is a committed student looking for a team of supporters.',
    protegeInterest: "I'd like to be a protege",
    backrDescription:
      'A backr is a well-intended person looking to support a protege on their journey.',
    backrInterest: "I'd like to be a backr",
  },
  workflows: {
    firstTimeUser: {
      body: 'Welcome to Backrs, a community where students and professionals champion each other’s academic, career, and life goals.',
      ctaLabel: "Let's go!",
    },
    meetTheProteges: {
      purposeStatement: 'Purpose Statement',
    },
    meetTheBackrs: {
      aboutHeader: 'About',
      interestsHeader: 'Interests',
    },
  },
  feed: {
    errors: {
      feedUnavailable: "Uh oh! Your feed isn't loading.",
      filtersUnavailable: 'Feed Filters Unavailable',
      contactSupport: 'Contact Support',
    },
  },
  catchup: {
    pass: 'Pass',
    later: 'Later',
    done: 'Done',
    ask: 'Ask: ',
    addResponse: 'Add your response here',
    sendMessage: 'Let’s talk live! Send me a message.',
    respondTo: (name) => `Respond to ${name}`,
    allCaughtUp: 'You’re all\ncaught up!',
    feedUnavailable: 'Catchup feed is unavailable, try again later',
    nextUp: 'Next Up',
    mensch: 'What a mensch!',
    catchup: 'Catch Up',
    whyAmISeeing: 'Why am I seeing this post?',
    whyYouAreSeeing: 'This was posted in one of your Networks or by a student you back. Thanks to your interests and experience, we believe you could give valuable insight on this ask! Simply type to respond, or you can hit “later” to save the ask for a better time.',
  },
  post: {
    createPost: {
      possibleAsks: [
        {
          id: 1,
          name: 'recommendation',
          phrase: 'I need a recommendation',
        },
        {
          id: 2,
          name: 'connection',
          phrase: 'I need a connection',
        },
        {
          id: 3,
          name: 'resources',
          phrase: 'I need resources',
        },
        {
          id: 4,
          name: 'affirmation',
          phrase: 'I need affirmation',
        },
        {
          id: 5,
          name: 'celebration',
          phrase: 'I want to celebrate',
        },
        {
          id: 6,
          name: 'meeting',
          phrase: 'I need to meet with my panel',
        },
      ],
      networks: 'Networks',
      panels: 'Panels',
      selectOption: 'Select Option',
    },
    actions: {
      copyLink: 'Copied link!',
      moreComments: 'More Comments',
      editPost: 'Edit Post',
      editGoal: 'Edit Goal',
      deletePost: 'Delete Post',
      deleteGoal: 'Delete Goal',
      reportPost: 'Report Post',
    },
    userPanel: (userName) => `${userName}'s Panel`,
    managing: {
      state: {
        uploadingMedia: 'Uploading Media...',
        mediaSelected: 'Media Selected',
      },
      errors: {
        exceedPdfSize: 'The pdf you tried to upload was too large. Try uploading a pdf with a file size less than 1GB.',
        exceedPdfMaxSum: "You've exceeded the total pdf storage that is allowed.",
        failedUpload: 'Failed to upload media. Please try again.',
      },
    },
  },
  report: {
    backButtonText: {
      posts: 'Report Post',
      comments: 'Report Comment',
      users: 'Report User',
      conversations: 'Report Conversation',
    },
    reportType: {
      posts: 'post',
      comments: 'comment',
      users: 'user',
      conversations: 'conversation',
    },
    categories: {
      posts: {
        offensive: 'I found it offensive',
        spam: "It's spam",
        copyright: 'Copyrighted material',
      },
      comments: {
        offensive: 'I found it offensive',
        spam: "It's spam",
        copyright: 'Copyrighted material',
      },
      users: {
        offensive: 'Offensive or abusive behavior',
        spam: 'Spam',
        copyright: 'Copyrighted Material',
        inappropriate: 'Inappropriate Direct Messaging Content',
      },
      conversations: {
        offensive: 'Offensive or abusive behavior',
        spam: 'Spam',
        copyright: 'Copyrighted Material',
        inappropriate: 'Inappropriate Direct Messaging Content',
      },
    },
    submitButton: {
      posts: 'Submit Report',
      comments: 'Submit Report',
      users: 'Report User',
      conversations: 'Report Conversation',
    },
    placeholders: {
      reason: 'Let us know the details behind your report.',
    },
  },
  teams: {
    multiSelect: 'Select a protege to view',
    yourTeams: 'Your Panels',
    unlockTeams: {
      title: 'Unlock Panels',
      body: 'Want to play a more involved role in a student’s journey? Answer some quick Q’s so you can back a protege!',
      button: 'Join a Panel',
      verifyButton: 'Check my status',
    },
  },
  invest: {
    fail: {
      noDonorbox: 'Your protege does not yet have an invest page. Check back for updates!',
      otherWays: 'Other ways to invest',
      additionalOptions:
        'Backrs offers additional options to financially invest in one or more proteges.',
    },
  },
  hamburgerMenu: {
    tourNavigation: 'Tour the app',
    myProfile: 'My Profile',
    learnAndExplore: 'Learn and explore',
    financiallyBack: 'Financially Back',
    sendInvite: 'Refer a Friend',
    sendInviteWeb: "mailto:?subject=Convenient, Rewarding Volunteer Opportunity&body=I'm using the Backrs app to share my knowledge, connections, and extra funds with high-performing but under-resourced students. The time commitment is minimal (10 mins or less a week), but the impact is truly meaningful.%0D%0A%0D%0AYou'd love being a backr as much as I do. Click this link to download the app and try it out!%0D%0A%0D%0Ahttps://onelink.to/backrs%0D%0A%0D%0A",
    logOut: 'Log Out',
    joinATeam: 'Join a Panel',
    getVerified: 'Background Check',
    contactSupport: 'Get Support',
    blueprint: 'Blueprint',
    resourceLibrary: 'Prosper',
    ai: 'Lubav',
    grow: 'Dashboard',
    faq: 'FAQ',
  },
  tour: {
    youreIn: "Let's Explore",
    takeOurTour: 'Take Our Tour',
    videoError: 'Unable to load backrs tour at this time',
    tourCtaScreen: {
      verifiedMsg:
        "You're one step closer to backing a protege. Before getting matched, explore our community!",
      exploreLink: "I'll explore on my own",
    },
    tourAlertCard: {
      takeTourCta: 'Take a tour of the app!',
      verifiedHoldMsg:
        'While you wait to be verified, explore the features that Backrs has to offer.',
      imgFailedToLoad: 'Image Unavailable',
      altImageText: 'Take tutorial asset',
    },
  },
  wholeMe: {
    skipPersonalization: 'Skip Personalization',
    save: 'Save',
    wholeMeAlertCard: {
      header: 'Complete your profile!',
      body: 'Proteges are more likely to select backrs with a robust profile.',
    },
    wholeMeEducationIntake: {
      title: 'What’s your school?',
      subtitle: 'Please indicate where you currently go to school.',
    },
    wholeMeGradeYearIntake: {
      title: 'What’s your grade/year?',
      subtitle: 'Some opportunities we share are grade-specific.',
    },
    wholeMeSponsorIntake: {
      title: 'How’d you hear about us?',
      subtitle: 'An employer like McKinsey? An org like TFA? A volunteer site? Google? If you’re not sure, type “other.”',
    },
    wholeMeGenderIntake: {
      title: 'Gender',
      subtitle: 'Sometimes, opportunities we share for students and professionals are gender-specific.',
    },
    wholeMeEthnicityIntake: {
      title: 'Ethnicity',
      subtitle: 'This info helps us ensure community members are able to make diverse connections.',
    },
    wholeMeAffinityIntake: {
      title: 'More Affinities',
      subtitle: 'Our community members have a range of identities and experiences. Do any of these apply to you?',
    },
    wholeMeZipIntake: {
      title: 'Zip Code',
      subtitle: 'Your zip code helps us connect you with location-based networks or backing opportunities.',
    },
    wholeMeCareerFieldIntake: {
      title: 'Career Paths',
      subtitle: 'Which Career-Path Networks do you want to join? Choose fields you’re interested or experienced in.',
    },
    wholeMeLinkedinIntake: {
      nativeHowToSubtitle: [
        'Tap your profile photo.',
        'Tap View profile.',
        'Tap on the More icon next to Add section button.',
        'Tap Contact info.',
        'www.linkedin.com/in.',
      ],
      webHowToSubtitle: [
        'Tap your LinkedIn profile photo.',
        'Locate the “Public profile & URL” box in the upper left of your screen.',
        'Copy the link in this box.',
      ],
      howToTitle: 'How do I find my LinkedIn URL?',
      errMsg: 'Invalid URL, Expected Format: www.linkedin.com/in/john-doe',
      locateUrl: "Under the Your Profile section, locate your public profile URL. It'll be an address that starts with:",
      title: "What's your LinkedIn?",
      subtitle: 'We use LinkedIn to fill out your profile and find more connections for you across our community.',
      inputPlaceholder: 'LinkedIn Profile Url',
      urlPlaceholder: 'URL',
      dontHave: 'I don’t have one.',
      professionalTitle: 'Got a professional page?',
      professionalSubtitle: 'If your bio is available elsewhere online or you have a professional site/digital portfolio, you can share that as well!',
      dontHaveEither: 'I don’t have one of these either.',
    },
    wholeMePhotoIntake: {
      title: 'Upload a Profile Pic',
      subtitle: 'Our community members want to put a face to the name. Having a profile pic builds trust 😁',
    },
    wholeMeBirthdayIntake: {
      title: 'What’s your birthday?',
      subtitle: 'This info helps us keep our community safe.',
    },
    wholeMeIdentity: {
      identity: 'Identity',
      scholar: 'Scholar',
      zip_code: 'Zip Code',
      gender: 'Gender',
      affinity: 'Affinity',
      ethnicity: 'Ethnicity',
      occupation: 'Occupation',
      birth_date: 'Birth Date',
    },
  },
  wholeMeProfileAvatarBusinessRoleText: {
    protege: 'protege',
    admin: 'friendly cyborg helper',
    backr: 'backr',
  },
  wholeMeProfilePurposeVideo: {
    cardTitle: 'Add a short video explaining who you are and what brought you to Backrs!',
    intakeTitle: 'Video Introduction',
    intakeSubtitle: 'Introduce yourself and the goals you want to achieve with Backrs.',
    seeExample: 'I want to see an example video.',
    skip: "I'll do this later.",
  },
  goals: {
    noPublicGoals: "This protege doesn't have any public goals",
    seeUpdates: (updateCount) => (updateCount === 0 ? 'No Updates'
      : updateCount === 1 ? `${updateCount} Update` : `${updateCount} Updates`),
    achieved: 'Goal Achieved!',
    confirmDelete: 'Do you want to delete this goal?',
    yesDelete: 'Yes, delete it',
    noDelete: 'No, keep it',
    accomplishMore: 'Accomplish even more with Backrs.',
    addNewGoal: 'Add a new goal',
    labels: {
      allLabel: 'All Goals',
      mindsets: 'Mindsets',
      fundamentals: 'Fundamentals',
      wellness: 'Wellness',
      finances: 'Finances',
      academics: 'Academics',
      careers: 'Careers',
      goal: 'Goal',
    },
    unlockGoals: {
      title: 'Unlock Goals',
      body: "Your proteges' goals will load soon",
      button: 'Back a Protege',
      verifyButton: 'Check my status',
    },
    noGoals: {
      title: 'You don’t have any goals yet!',
      cardTitle: 'Write your first goal',
      cardBody: 'Use the + sign to create a goal tied to your passions, academics, career, and more!',
    },
    smartGoals: {
      whatIs: 'What is a',
      smart: 'SMART',
      goal: 'goal?',
      whenDesigning: 'When designing your goal, keep the following in mind:',
      specific: 'Specific',
      directDetailedMeaningful: 'Your goal is direct, detailed, and meaningful.',
      SMART: ['S', 'M', 'A', 'R', 'T'],
      measureable: 'Measureable',
      quantifiable: 'Your goal is quantifiable to track progress or success.',
      attainable: 'Attainable',
      realistic: 'Your goal is realistic and you have the tools and/or resources to attain it.',
      relevant: 'Relevant',
      aligns: 'Your goal aligns with your personal mission.',
      timeBased: 'Time-based',
      description: 'Your goal has a deadline.',
      example: 'An example SMART goal:',
      improve: '"I want to improve my physical health by being active for 30 minutes, 3 times per week."',
      gotIt: 'Got it!',
    },
    goalsType: {
      title: 'Choose a goal category:',
    },
    goalsSubtype: {
      title: (type) => `What aspect of ${type}?`,
      drawerTitle: 'New Goal Subtype',
      ctaLabel: 'Save',
      placeholder: 'Enter a new subtype',
    },
    smartGoalTemplate: {
      title: 'Start with a template',
      writeMyOwn: 'Write my own',
    },
    goalsCreate: {
      title: 'Create your SMART goal',
    },
    goalsEdit: {
      title: 'Edit your SMART goal',
    },
    goalsCommon: {
      shareWith: 'Share with',
      myPanel: 'My Panel',
      makePublic: 'Make Public',
      goalProgress: 'Goal Progress',
      inProgress: 'In Progress',
      completed: 'Completed',
      public: 'Public',
    },
    goalsCelebration: {
      congratulations: 'Congratulations!',
      goalAchieved: 'You achieved your goal!',
      greatJob: 'Great job on your hard work and dedication.',
      considerSharing: 'Consider sharing an update with your teammates to let them know about this incredible achievement!',
      takeoff: 'Takeoff',
      rocketship: 'Rocketship',
      shareAnUpdate: 'Share an Update',
      returnToGoals: 'Return to Goals',
      health: 'I improved my physical health!',
      academic: 'I achieved my academic goal!',
      passion: 'I achieved my passion goal!',
      career: 'I improved my career outlook!',
      iImproved: (type) => `I improved my ${type}!`,
    },
  },
  validationErrors: {
    cityReq: 'City is required.',
    stateReq: 'State is required.',
    excitedAgeGroupReq: 'Invalid value',
    excitedReq: 'Reason for excitement is required',
  },
  learnExplore: {
    header: 'Learn and Explore',
    meetOurBackrs: 'Meet our Backrs',
    meetOurProteges: 'Meet our Proteges',
    backingInAction: 'Backing in Action',
    whatIsBacking: 'What is backing?',
    primaryButton: "Let's Go!",
    aboutBackrs: {
      aboutHeader: 'About Backrs',
      cards: [
        {
          header: 'Backrs is a movement',
          img: 'assets/handmegaphone.svg',
          alt: 'hand holding megaphone',
          body: 'We hope to catalyze a global movement that drives more effective and inclusive backing. Everyone is worthy of a diverse, committed, and well-resourced group of people who have their back.',
        },
        {
          header: 'Backrs is a community',
          alt: 'hands holding up a globe',
          img: 'assets/icon/holdingworld.svg',
          body: 'We are a diverse group excited to help each other back and be backed. Backrs is also a community of institutions - school, businesses, nonprofits and health care providers - all committed to backing.',
        },
        {
          header: 'Backrs is a platform',
          img: 'assets/icon/platformicon.svg',
          alt: 'hand holding up a phone',
          body: 'We create digital experiences that are inclusive, supportive, trustworthy, and rewarding so that a diverse set of individuals and institutions can back and be backed. ',
        },
      ],
    },
  },
  whatIsBackrs: {
    header1: 'Backrs: A Social App for',
    header2: 'Social Mobility',
    subheader: 'We connect high-performing, under-resourced students with adults (like you) who empower them to realize their potential.',
    backingdata: {
      linedGroup: [
        {
          title: 'Students share:',
          body: 'Goals, questions, challenges, and requests for support.',
          icon: 'assets/icon/green-square.svg',
          iconClass: 'WIB-icon1',
        },
        {
          title: 'You’ll share:',
          body: 'Knowledge, connections, funds, and encouragement.',
          icon: 'assets/icon/blue-triangle.svg',
          iconClass: 'WIB-icon2',
        },
        {
          title: 'Students get:',
          body: 'The help they need to succeed in school and secure fulfilling, well-paying jobs.',
          icon: 'assets/icon/yellow-circle-half.svg',
          iconClass: 'WIB-icon3',
        },
        {
          title: 'You’ll get:',
          body: 'The chance to give back meaningfully and on your terms.',
          icon: 'assets/icon/grey-circle.svg',
          iconClass: 'WIB-icon4',
        },
        {
          title: 'Everyone grows.',
          body: 'By connecting with people outside of their bubble.',
          icon: 'assets/icon/orange-diamond.svg',
          iconClass: 'WIB-icon5',
        },
      ],
    },
    primaryButton: 'Let’s go!',
  },
  unsureModal: {
    header: "We'd love to hear from you!",
    subheader:
      'If our protege suggestions were not a good fit, let us know how we can support in your match.',
    submit: 'Submit',
    textarea: {
      name: 'reason',
      label: 'What are you looking for?',
      placeholder: 'Let us know in detail your backing preferences.',
    },
    dropdown: {
      name: 'preferred_contact',
      label: 'Preferred Contact',
      choices: [
        { label: 'Email', value: 'email' },
        { label: 'Text', value: 'text' },
      ],
      defaultValue: 'email',
    },
  },
  matchingQuiz: {
    header: 'Student Preferences',
    subheader:
      'Let us know what age you would like to support! We promise to honor your preferences. ',
    submit: 'Create Profile',
    demographicInfo: {
      header: 'Demographic Information',
      body: 'This is the information that is most useful to create a diverse team that aligns with a protege’s needs.',
      identityHeader: 'Identity Affiliation',
      identityBody:
        'This information helps us build diverse teams and address our protege’s needs and preferences Info  will be visible to the Backrs community.',
    },
    sharedIdentity: {
      header: ' Shared Identity',
      body: 'We strive to build diverse teams, and many backrs and proteges prefer to have at least a few members of their team that share particular aspects of identity. If you’d like us to try to find a protege that shares one or more of the aspects you identified, check yes. If you have no preference, leave blank.',
    },
    matchingResults: {
      header: 'You’ll be a great backr!',
      subHeader:
        'Here are some students who would benefit from your support. Want to back any of them?',
      buttonLabel: 'Start Backing Them',
      unsure: "I'm not ready",
      noResults: {
        header: 'Uh Oh!',
        button: 'Search again',
      },
      noResultsBody: {
        para1:
          "We couldn't find any students that match your preferences right now. We've put you on our wait list and will contact you when we have a match.",
        para2:
          "If you'd like to back available students, try your search again or omit your cohort code.",
      },
    },
    splashPage: {
      title: 'Profile Created!',
      subtitle: 'Woohoo! Now, you can answer a few questions about the protege you’d like to back.',
      noPreferences: 'Skip it, I have no preferences',
    },
    cohortCodePage: {
      title: 'Cohort Code',
      subtitle: "If you're hoping to back 1-3 students from a specific cohort, type their cohort code here.",
      noCode: 'Don’t have a cohort code?',
      placeholder: '123456',
    },
  },
  startBgCheckScreen: {
    header: 'Get verified!',
    body: 'Backing works best when you can communicate with students directly.  To maintain a safe community, you\'ve got to pass a quick background check first.',
    checkrInfo: [
      'Background checks are free',
      'All information is confidential',
      'There’s no impact to credit',
    ],
    startBgCheck: 'Start Background Check',
    exploreTeam: 'Explore the team',
    maybeLater: 'I\'ll do this later',
  },
  checkrStatusScreen: {
    header: 'We’ll take it from here.',
    body: 'Your background check is now in flight and will take between 10 mins to 48 hours to clear. Once it does, you’ll be able to connect with your protege!',
    bodyNoBG:
      "Your background check is essential and typically takes 10 min to 48 hours to clear. Once complete, you'll be able to fully engage with your team soon! In the meantime, proceed to the link below to complete your background check.",
    lubavCard: {
      title: 'Meet Coach Lubav',
      body: 'Learn all about our cyborg super-backr and how Lubav makes it easier and more rewarding for you to back.',
    },
    noBgCard: {
      title: 'Background Check',
      body: 'Please click here to complete your background check so you can be matched with a protege as soon as possible!',
    },
    headToFeedCard: {
      title: 'Head to your feed',
      body: 'There, you can respond to some Backing Opportunities while you wait for your background check to clear.',
    },
  },
  checkrFormScreen: {
    body: 'Backrs is committed to safety. As part of that commitment, we partner securely with Checkr, the industry leader in consumer reports, to ensure the safety of our proteges (many of whom are minors). In order to communicate with a proteges, you must undergo a background check. These checks are private and confidential, guaranteeing that your information is not shared with the Backrs team or greater Backrs community.',
    termViewButton: 'checkr terms',
    termAccept: 'I accept ',
    disclosureLabel: 'I accept this disclosure regarding background investigation',
    rightsLabel:
      'I acknowledge this receipt of the Summary of Your Rights Under the Fair Credit Act',
    reportLabel: 'Send me my checkr report',
    submit: 'submit',
    continueExploring: 'Continue exploring',
    payPage: {
      header: 'Will you cover the cost?',
      body: 'Each background check cost Backrs $35. If you can pay for your own, you enable us to use those funds to support more students.',
      noThanks: 'No thank you',
      yes: 'Yes',
    },
  },
  profileCompleted: {
    header: 'Profile Complete!',
    subheader: "Wow, you did it! You're a star! Feel free to edit any of your answers in your profile mode.",
    navText: 'View your whole profile',
    imgAltText: 'badge signifying profile completion',
    mainFeed: 'Take me to the main feed',
  },
  faq: {
    header: 'Need help? We’ve got your back.',
    subheader1: 'Check out our FAQs below or',
    subheader2: 'for support.',
    message: 'contact support',
  },
  toasts: {
    photoDenied: 'To upload a photo from your camera roll, please allow access to your photos via app settings.',
    cameraDenied: 'To take a photo, please allow access to your camera via app settings.',
    failedUpload: 'Failed to upload photo. Please try again.',
    goToSettings: 'Go To Settings',
    maybeLater: 'Maybe Later',
    dismiss: 'Dismiss',
  },
  share: {
    title: 'Take Part in the Backrs Community!',
    body: "I'm using the Backrs app to share my knowledge, connections, and extra funds with high-performing but under-resourced students. The time commitment is minimal (10 mins or less a week), but the impact is truly meaningful. You'd love being a backr as much as I do. Click this link to download the app and try it out!",
    url: 'https://onelink.to/backrs',
    dialogueTitle: 'Take Part in the Backrs Community!',
  },
  profile: {
    actionButtons: {
      messageAdmin: 'Contact Support',
      meet: 'Meet',
      invest: 'Invest',
      back: 'Back',
      backing: 'Backing',
      proposed: 'Proposed',
    },
    unlockProfile: {
      title: 'Profile Locked!',
      body: 'In order to view profiles of proteges under the age of 18, you’ll need to pass a one-time background check.',
      buttonLabel: 'Background Check',
    },
    blockedProfile: {
      title: 'Profile Restricted!',
      body: 'This profile has been blocked from view for safety reasons. Please contact support for more information.',
    },
    unavailableProfile: {
      title: 'Uh Oh!',
      body: 'This profile is unavailable. If you think this is an error, contact support.',
      cta: 'Contact Support',
    },
    backingModal: {
      ctaLabelBuilder: (protegeName) => `Join ${protegeName}'s Panel`,
      modalTitleBuilder: (protegeName) => `Champion ${protegeName}'s goals.`,
      topBody: 'Backing a student enables you to view their goals, stay up-to-date on their journey, and build a relationship with them over time. It involves:',
      modalListData:
        [
          'A supported intro over Zoom.',
          'Reading their updates.',
          'Responding to their questions.',
          'Talking 1x a quarter.',
        ],
      errorState: {
        topBodyError: 'Oops, something went wrong!',
        errorModalListData: [
          'There was an problem matching you with this protege',
          'Please contact support for more information',
        ],
        contactLubavLabel: 'Contact Support',
      },
      pendingState: {
        backgroundCheckPendingList: [
          'Check your background check status.',
          'Follow instructions and try again later.',
        ],
        topBodyPending: 'Looks like you require a background check to support this protege. Please do the following:',
        statusButtonLabel: 'View Status',
      },
    },
  },
  ageRestricted: {
    title: 'Whoa there!',
    body1: 'It looks like you are under 18, which means that you’re probably a protege, not a backr.',
    body2: 'Proteges are guided through the account creation process by our community team. Please contact support to get your account set up!',
    ctaLabel: 'Contact Support',
  },
  calendlyPage: {
    drawerData: [
      'Create an account at calendly.com.',
      'Tap “Availability.”',
      'Set your availability for 30 min calls.',
      'Tap your 30 min meeting event.',
      'Tap “Event details.”',
      'Set your meeting location for Zoom, a phone call, Google Meet, etc.',
      'Copy the event link, share here.',
    ],
    errMsg: 'Invalid URL, Expected Format: www.calendly.com/calendly-name',
    calendlySignupUrl: 'www.calendly.com/signup',
    title: 'Add your calendar!',
    subtitle: 'Help members of the community schedule time with you by sharing a link to your calendar.',
    inputPlaceholder: 'Calendar/Scheduling Link',
    dontHave: 'Don’t have one?',
    drawerTitle: 'Create a free scheduling link through Calendly:',
  },
  affinityNetwork: {
    howDidIJoinNetwork: 'How did I join this network?',
    affinityModal: {
      title: 'Affinity Networks',
      body: 'We added you to this network because your profile responses indicated it would be a good fit. If you think you’re in the wrong place or you’d like to opt out, contact support.',
      message: 'Contact Support',
    },
    affinityMember: {
      viewProfile: 'View Profile',
      scheduleTime: 'Schedule Time',
    },
    affinityMemberList: {
      uhOh: 'Uh Oh!',
      listNotFound: 'List not found.',
      tryRefresh: 'Try refreshing the page or',
      contactSupport: 'contact support.',
    },
  },
  comments: {
    postUnavailable: 'Post unavailable',
    photo: 'photo',
    addPhoto: 'Add Photo',
    video: 'video',
    addVideo: 'Add Video',
    file: 'file',
    addFile: 'Add File',
    me: 'Me ',
    coachLubav: 'Coach Lubav',
    replyingTo: 'Replying to',
    post: 'Post',
    mediaUploadError: 'Failed to upload media. Please try again.',
    user: 'User',
    sharedPhoto: 'shared a photo',
    sharedVideo: 'shared a video',
    sharedFile: 'shared a file',
    update: 'Update',
  },
  activate: {
    hey: 'Hey ',
    activateAccount: 'Activate your account!',
    tsAndCs: ' I certify that I am 14 years of age or older.',
    textVerification: 'Text Verification Code',
    tac: {
      acceptBtac: 'By registering, I accept',
      btac: 'Backrs Terms & Conditions',
    },
  },
  errorScreen: {
    title: 'Yikes! Something went wrong.',
    body: 'Try logging in again or contact ',
    body2: 'support to get more information.',
    contactSupport: 'Contact Support',
    login: 'Login',
  },
  version: {
    updateAppScreen: {
      header1: "It's been a while!",
      header2: 'Time to update your app.',
      body: "We've added some cool new features that you just have to see 😁",
      button: {
        label: 'Update the Backrs App',
      },
    },
  },
  blocking: {
    admin: {
      modal: {
        title: 'Are you sure?',
        body: "Blocking Coach Lubav will prevent you from accessing Backrs content and the backrs platform, effectively disabling your account. If you're having second thoughts, contact our admin first.",
        button: { confirm: 'Confirm and Block' },
      },
    },
    users: {
      modal: {
        blockBody: (name) => `You & ${name} will no longer be able to communicate or view each other's posts and comments.`,
        unBlockBody: (name) => `You & ${name} will be able to communicate and view each other's posts and comments.`,
        title: 'Are you sure?',
        button: { confirm: 'Confirm & Block', cancel: 'cancel', unblock: 'Unblock' },
      },
    },
  },
  wholeMeProfileStory: {
    deleting: {
      confirm: 'Yes',
      cancel: 'Cancel',
      areYouSure: 'Are you sure you want to delete',
    },
    documentSection: {
      subText: 'Share these documents to do something useful.',
      uploadButton: {
        label: 'Upload another file or link',
      },
    },
    storySection: {
      uploadMeta: {
        title: 'Share your knowledge',
        description: (section) => `Add video or text to help others in the community learn from your ${section === 'academic' ? 'education' : section}.`,
      },
    },
    modal: {
      description: 'Description',
      title: 'Title',
      whoCanSee: 'Who can see this?',
      uploadDocument: 'Upload A Document',
      editStory: 'Edit Your Story',
      uploadFile: 'Upload File',
      uploadVideo: 'Upload Video',
      editStoryTitle: 'Edit Your Story',
      createAStory: 'Share Your Reflection',
      failedToSave: 'Failed to save to profile',
      panel: 'My Panel',
      public: 'Public',
      deleteThis: 'Delete This Story?',
      fileName: 'File Name',
      videoTitle: 'Video Title',
      textTitle: 'Text Title',
      characterLimit: (charCount) => `${charCount}/50`,
      resume: 'Resume',
      transcript: 'Transcript',
      other: 'Other',
    },
    errors: {
      mediaError: (mediaType) => `Error uploading your ${mediaType}, please try again!`,
      requestError: 'There was an error with your request, please try again!',
      characterLimit: 'Story video description can not exceed 50 characters',
      document: 'document',
      video: 'video',
    },
  },
  wholemeIntake: {
    transcriptUpload: {
      title: 'Transcript',
      subtitle: 'Share a link, PDF, or screenshot of your unofficial transcript.',
      howToGet: 'How do I get my transcript?',
      drawerSubTitle: "You can find an unofficial transcript in your school's student portal or online grade book.",
    },
    resumeUpload: {
      title: 'Resume',
      subtitle: 'This will help us understand your background and experience.',
      noResume: "I don't have one.",
      drawerTitle: 'What if I don’t have a resume?',
      drawerContent: 'That’s okay! You can add one to your profile later. We’ll reach out via email with some resources that will help you put together a strong resume. For now, tap “Save and Continue” to skip.',
    },
    splashText: {
      thankYou: {
        title: 'Thank you!',
        subtitle: 'We’re adding you to Networks where you can meet community members with shared affinity.',
        subtitle2: 'We’d also like to add you to Career-Path Networks.',
        loadingText: 'Loading a couple more Qs...',
      },
      giveBack: {
        title: 'Give back, get ahead.',
        subtitle1: 'Our community is made of up of',
        subtitle2: 'thousands',
        subtitle3: 'of people who are helping each other succeed every day.',
        subtitle4: "You'll fit right in!",
        loadingText: 'Creating your account...',
      },
      woohoo: {
        title: 'Woohoo!',
        subtitle: 'Thanks to the info you shared, we can match you with the right opportunities to give back and get ahead.',
      },
    },
  },
  growBanner: {
    title: 'Backrs is making big moves!',
    description: 'Explore your new Backrs hub and all the features we have to offer.',
    link: 'Go to my dashboard',
  },
};
